import { aggregateSumFuncByField } from '../ClassificationTable/utils';

export const GQL_METHOD = 'unclassifiedPersonnelSpends';
export const SORTING_TYPE = 'UnclassifiedPersonnelSpendGroupSort';
export const FILTER_TYPE = 'UnclassifiedPersonnelSpendGroupFilter';

export const PARENT_COLUMNS = {
  clientRole: 'clientRole',
  businessUnit: 'businessUnit',
  cost: 'cost',
};

export const CHILDREN_COLUMNS = {
  apSpendCategoryL1: 'apSpendCategoryL1',
  apSpendCategoryL2: 'apSpendCategoryL2',
  categoryL1Code: 'categoryL1Code',
  categoryL2Code: 'categoryL2Code',
  cost: 'cost',
  periodReference: 'periodReference',
  permanentOrContract: 'permanentOrContract',
  country: 'country',
  employeeName: 'employeeName',
  spendType: 'spendType',
  id: 'id',
};

export const GROUP_KEY = PARENT_COLUMNS.clientRole;
export const GROUP_HEADER = 'Client Role';

export const COLUMN_DEFS = [
  {
    field: PARENT_COLUMNS.clientRole,
    hide: true,
    lockVisible: true,
  },
  {
    field: PARENT_COLUMNS.businessUnit,
  },
  {
    field: CHILDREN_COLUMNS.employeeName,
  },
  {
    field: CHILDREN_COLUMNS.cost,
    valueGetter: aggregateSumFuncByField(CHILDREN_COLUMNS.cost),
    filter: 'agNumberColumnFilter',
  },
  {
    headerName: 'Taxonomy',
    marryChildren: true,
    children: [
      {
        field: CHILDREN_COLUMNS.apSpendCategoryL1,
        cellClass: 'taxonomy-item',
        lockVisible: true,
      },
      {
        field: CHILDREN_COLUMNS.apSpendCategoryL2,
        cellClass: 'taxonomy-item',
        lockVisible: true,
      },
    ],
  },
  {
    field: CHILDREN_COLUMNS.country,
  },
  {
    field: CHILDREN_COLUMNS.periodReference,
    filter: 'agDateColumnFilter',
  },
  {
    field: CHILDREN_COLUMNS.spendType,
  },
  {
    field: CHILDREN_COLUMNS.id,
    filter: 'agNumberColumnFilter',
  },
  {
    field: CHILDREN_COLUMNS.permanentOrContract,
  },
];

export const config = {
  gridConfig: {
    columnDefs: COLUMN_DEFS,
  },
  columnParams: {
    groupColumnKey: GROUP_KEY,
    groupHeader: GROUP_HEADER,
    parentColumns: PARENT_COLUMNS,
    childrenColumns: CHILDREN_COLUMNS,
    gqlMethod: GQL_METHOD,
    sortingType: SORTING_TYPE,
    filterType: FILTER_TYPE,
  },
};

export default config;
